/**
 * @generated SignedSource<<2d926121014047371cc96c84373eeccc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_viewer$data = {
  readonly pdpRareFindTreatment: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_viewer">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_viewer";
};
export type PdpRespSidebarBlurbs_viewer$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_viewer",
  "selections": [
    {
      "alias": "pdpRareFindTreatment",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpRareFindTreatment"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpRareFindTreatment\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2bac25f241d00795c85e0aca5fcfa5a5";

export default node;
